module.exports = __webpack_public_path__ + "img/VetoSans-LightItalic_1.d2b6e9d1.svg";